import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ExerciseModel } from '../../../models/exercise.model';
import { AcModel } from '../../../models/ac.model';
import { UntypedFormBuilder } from '@angular/forms';
import { SlotModel } from '../../../models/slot.model';
import { ElementModel } from '../../../models/element.model';
import { faBullhorn, faStreetView, faUsers } from '@fortawesome/pro-light-svg-icons';
import { AcStatusSettingsExerciseSlotType, AcStatusSettingsExerciseType, RatingstartType } from '../../../models/acstatus/ac-status.type';

enum PermissionType {
  Candidate = 'candidate',
  Observer = 'observer',
  Moderator = 'moderator',
}

@Component({
  selector: 'app-exercise-settings-slots',
  templateUrl: './exercise-settings-slots.component.html',
  styleUrls: ['./exercise-settings-slots.component.scss']
})
export class ExerciseSettingsSlotsComponent implements OnInit, OnChanges {

  @Input() ac: AcModel = null;
  @Input() exercise: ExerciseModel = null;

  public status: { [key: number | string]: AcStatusSettingsExerciseSlotType } | null;
  public elements: Array<ElementModel> = [];
  public slots: Array<SlotModel> = [];

  public columns = 0;
  public RatingstartType = RatingstartType;

  public faStreetView = faStreetView;
  public faUsers = faUsers;
  public faBullhorn = faBullhorn;

  constructor(
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.ac && this.exercise) {
      this.buildSlots();
      this.buildElements();
      this.initStatus(this.ac.getExerciseStatus(this.exercise.id));
    }
  }

  public getPayload(): { [key: number | string]: AcStatusSettingsExerciseSlotType } | null {
    return this.status;
  }

  public setDuration(slot: SlotModel, data: any): void {
    this.status[slot.id].duration = (!isNaN(data)) ? parseInt(data) : null;
  }

  public setRatingDuration(slot: SlotModel, data: any): void {
    this.status[slot.id].rating_duration = (!isNaN(data)) ? parseInt(data) : null;
  }

  public togglePermission(slot: SlotModel, element: ElementModel, type: PermissionType): void {
    if (this.isAvailable(slot, element)) {
      if (this.status[slot.id]?.permissions[element.id].includes(type)) {
        this.status[slot.id].permissions[element.id] = this.status[slot.id].permissions[element.id].filter(actual => actual !== type);
      } else {
        this.status[slot.id]?.permissions[element.id].push(type)
      }
    }
  }

  public isAvailable(slot: SlotModel, element: ElementModel): boolean {
    const result = this.status[slot.id] &&
      Array.isArray(this.status[slot.id].permissions[element.id]);
    return result;
  }

  public isForbidden(slot: SlotModel, element: ElementModel, type: PermissionType): boolean {
    return !this.isAvailable(slot, element) || !this.status[slot.id]?.permissions[element.id].includes(type);
  }

  private buildSlots(): void {
    this.slots = this.ac.slots.filter(slot => slot.exercise_id === this.exercise.id);
    this.columns = 0;
    this.slots.forEach((slot: SlotModel) => {
      this.columns += (slot.rating_start === RatingstartType.End) ? 2 : 1;
    });
  }

  private buildElements(): void {
    this.elements = [];
    this.slots.forEach((slot: SlotModel) => {
      slot.elements.forEach((element: ElementModel) => {
        if (!this.elements.find(actual => actual.id === element.id)) {
          this.elements.push(element);
        }
      });
    });
    this.elements.sort((a, b) => a.position - b.position);
  }

  private initStatus(status: AcStatusSettingsExerciseType): void {
    this.status = status?.slots || null;
    if (!this.status) {
      this.status = {};
    }
    this.slots.forEach((slot: SlotModel) => {
      if (!this.status[slot.id]) {
        this.status[slot.id] = {
          duration: slot.duration,
          rating_duration: slot.rating_duration,
          permissions: {}
        };
      }
      if (!this.status[slot.id].duration) {
        this.status[slot.id].duration = slot.duration;
      }
      if (!this.status[slot.id].rating_duration) {
        this.status[slot.id].rating_duration = slot.rating_duration;
      }
      if (!this.status[slot.id].permissions) {
        this.status[slot.id].permissions = {};
      }
      slot.elements.forEach((element: ElementModel) => {
        if (!this.status[slot.id].permissions[element.id]) {
          this.status[slot.id].permissions[element.id] = element.permissions;
        }
      });
    });
  }

}
